import { render, staticRenderFns } from "./Contribute.vue?vue&type=template&id=4fdff061&scoped=true"
import script from "./Contribute.vue?vue&type=script&lang=js"
export * from "./Contribute.vue?vue&type=script&lang=js"
import style0 from "./Contribute.vue?vue&type=style&index=0&id=4fdff061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdff061",
  null
  
)

export default component.exports